module.exports = __webpack_public_path__ + "static/media/blog-29-image-1.8adaf608.webp";